// app/javascript/modules/admissoes/dependentes_docs.js

export function initDependentesDocs($form, h) {
  const { hide, show, parseDateSmart, calcAge } = h
  const ns = ".admissaoDependentes"

  // --- Controle de "Possui Dependentes?" ---

  function syncPossuiDependentes() {
    const val = $form.find('input[name="params[possui_dependentes]"]:checked').val()
    const $conteudo = $form.find("#secao-dependentes-conteudo")

    if (val === "Sim") {
      $conteudo.show()
      // re-avalia docs do primeiro dependente
      syncDocsPrimeiroDependente()
    } else {
      $conteudo.hide()
      // esconde docs do primeiro dependente
      $form.find("#docs-primeiro-dependente").hide()
    }
  }

  // --- Docs do primeiro dependente (Filho Valido + idade <= 15) ---

  function syncDocsPrimeiroDependente() {
    const possuiDep = $form.find('input[name="params[possui_dependentes]"]:checked').val()
    if (possuiDep !== "Sim") {
      $form.find("#docs-primeiro-dependente").hide()
      return
    }

    const grau = $form.find("#params_grau_parentesco_dependente").val()
    if (grau !== "Filho Válido") {
      $form.find("#docs-primeiro-dependente").hide()
      return
    }

    const dn = parseDateSmart($form.find("#params_data_nascimento_dependente").val())
    if (!dn) {
      $form.find("#docs-primeiro-dependente").hide()
      return
    }

    const idade = calcAge(dn)
    if (idade !== null && idade <= 15) {
      $form.find("#docs-primeiro-dependente").show()
    } else {
      $form.find("#docs-primeiro-dependente").hide()
    }
  }

  // --- Bind events ---

  $form.off(ns)
  $form.on(`change${ns}`, 'input[name="params[possui_dependentes]"]', syncPossuiDependentes)
  $form.on(`change${ns}`, "#params_grau_parentesco_dependente, #params_data_nascimento_dependente", syncDocsPrimeiroDependente)

  return {
    apply() {
      syncPossuiDependentes()
    },
    destroy() { $form.off(ns) }
  }
}
